import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Menu, X } from 'lucide-react';
import { fetchAllChats } from '../services/chats';
import './Chats.css';

const Chats = () => {
  const [passwordPop, setPasswordPop] = useState(true);
  const [password, setPassword] = useState('');
  const [chats, setChats] = useState([]);
  const [selectedChat, setSelectedChat] = useState(null);
  const [error, setError] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetchAllChats(password);
      const fetchedChats = response.chats;

      const chatsArray = Array.isArray(fetchedChats)
        ? fetchedChats
        : Object.values(fetchedChats);

      if (chatsArray) {
        setChats(chatsArray);
        setPasswordPop(false);
        setError('');
        console.log(chatsArray);
      }
    } catch (err) {
      setError('Invalid password or unable to fetch chats.');
    }
  };

  const handleClosePasswordPopup = () => {
    setPassword('');
    setError('');
    navigate(-1);
  };

  const handleChatClick = (chat) => {
    setSelectedChat(chat);
    setIsMobileMenuOpen(false); // Close mobile menu after selecting a chat
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const getUserEmail = (chat, userId) => {
    return chat.userEmails[userId] || 'Unknown User';
  };

  const getEmailsFromChat = (chat) => {
    const userIds = chat.chatKey.split('_x_');
    const userEmails = chat.userEmails;

    return userIds.map((userId) => userEmails[userId] || 'NotFound');
  };

  return (
    <div className="admin-chats-page">
      {passwordPop && (
        <div className="password-popup">
          <span
            className="password-popup-close"
            onClick={handleClosePasswordPopup}
            role="button"
            aria-label="Close"
          >
            ✕
          </span>
          <h2>Enter Master Password</h2>
          <form onSubmit={handlePasswordSubmit}>
            <input
              type="password"
              placeholder="Master Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Submit</button>
          </form>
          {error && <p className="error-message">{error}</p>}
        </div>
      )}

      {!passwordPop && (
        <div className="chats-wrapper">
          {/* Header */}
          <div className="chats-header">
            <button onClick={() => navigate(-1)} className="chats-back-btn">
              <ArrowLeft size={16} />
              Back
            </button>
          </div>
          <div className="chats-section">
            {/* Desktop chat list - always visible on desktop */}
            <div className="chats-list desktop-chat-list">
              <h2>All Chats</h2>
              {chats.length > 0 ? (
                chats.map((chat) => (
                  <div
                    key={chat._id}
                    className={`chat-item ${selectedChat && selectedChat._id === chat._id ? 'active' : ''}`}
                    onClick={() => handleChatClick(chat)}
                  >
                    <p>
                      {getEmailsFromChat(chat)[0]} and{' '}
                      {getEmailsFromChat(chat)[1]}
                    </p>
                    <p>
                      Created At: {new Date(chat.createdAt).toLocaleString()}
                    </p>
                    <p>Messages: {chat.allMessages.length}</p>
                    <hr />
                  </div>
                ))
              ) : (
                <p>No chats available</p>
              )}
            </div>

            {/* Mobile header with hamburger */}
            <div className="mobile-chat-header">
              <button className="hamburger-btn" onClick={toggleMobileMenu}>
                {isMobileMenuOpen ? <X size={20} /> : <Menu size={20} />}
              </button>
              <h2>All Chats</h2>
            </div>

            {/* Mobile dropdown menu */}
            {isMobileMenuOpen && (
              <div className="mobile-chat-dropdown">
                {chats.length > 0 ? (
                  chats.map((chat) => (
                    <div
                      key={chat._id}
                      className={`chat-item ${selectedChat && selectedChat._id === chat._id ? 'active' : ''}`}
                      onClick={() => handleChatClick(chat)}
                    >
                      <p>
                        {getEmailsFromChat(chat)[0]} and{' '}
                        {getEmailsFromChat(chat)[1]}
                      </p>
                      <p>
                        Created At: {new Date(chat.createdAt).toLocaleString()}
                      </p>
                      <p>Messages: {chat.allMessages.length}</p>
                    </div>
                  ))
                ) : (
                  <p>No chats available</p>
                )}
              </div>
            )}

            <div className="chat-messages">
              {selectedChat ? (
                <div>
                  <h2>
                    Messages between {getEmailsFromChat(selectedChat)[0]} and{' '}
                    {getEmailsFromChat(selectedChat)[1]}
                  </h2>
                  <div className="messages-container">
                    {selectedChat.allMessages.map((message, index) => (
                      <div key={index} className="message-item">
                        <p>
                          {getUserEmail(selectedChat, message[0])}: {message[1]}
                        </p>
                        <small>
                          {new Date(message[2]).toLocaleTimeString()}
                        </small>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <p>Select a chat to view messages</p>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chats;

